export const ADD_EMPLOYMENT = 'ADD_EMPLOYMENT';
export const DELETE_EMPLOYMENT = 'DELETE_EMPLOYMENT';
export const ADD_STUDENT_EMPLOYMENT = 'ADD_STUDENT_EMPLOYMENT';
export const DELETE_STUDENT_EMPLOYMENT = 'DELETE_STUDENT_EMPLOYMENT';
export const SEARCH_EMPLOYER = 'SEARCH_EMPLOYER';